import { updateInverterInfo } from "../../../Features/inverterInformation";
import { updateProjectImg } from "../../../Features/projectImage";
import { updateQuantityInfo } from "../../../Features/quantityInfo";
import { projectInfo } from "../../../Features/roofInfo";

export const handleBOQ = (item, dispatch, setShow) => {
  console.log(item.quantityInfo);
  setShow(true);
  dispatch(updateInverterInfo(item.inverterInfo));
  dispatch(updateQuantityInfo(item.quantityInfo));
  dispatch(projectInfo(item));
  console.log(item);
};

export const handleInvoice = (item, dispatch, setShow) => {
  setShow(true);
  dispatch(updateInverterInfo(item.inverterInfo));
  dispatch(updateQuantityInfo(item.quantityInfo));
  dispatch(projectInfo(item));
};

export const handleProjectCompleted = async (
  item,
  projectList,
  setProjectList,
  setProjectComplete,
  setStatus
) => {
  // try {
  //   const projectIndex = projectList.findIndex(
  //     (project) => project.id === item.id
  //   );
  //   if (projectIndex !== -1) {
  //     const updatedProject = {
  //       ...projectList[projectIndex],
  //       statusInfo: {
  //         status: "Completed",
  //         updateDate: getCurrentDate(), // assuming getCurrentDate() is defined somewhere
  //       },
  //     };
  //     const newProjectList = [...projectList];
  //     newProjectList[projectIndex] = updatedProject;
  //     await updateDoc(doc(db, "projects", item.id), updatedProject);

  //     setProjectList(newProjectList);
  //     setProjectComplete(false);
  //     setStatus(true);
  //   } else {
  //     console.log("Project not found in the list.");
  //   }
  // } catch (error) {
  //   console.log("Error in Update Document", error);
  // }
};

export const handleDelete = async (
  item,
  setProjectList,
  setProjectDelete,
  setAlert
) => {
  console.log(item)
  try {
    // const projectRef = doc(db, "projects", item.id);
    // await deleteDoc(projectRef);
    setProjectList((prevList) =>
      prevList.filter((project) => project.id !== item.id)
    );
    setProjectDelete(false);
    setAlert(true);
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};

export const handleElectricalConfiguration = (e, dispatch) => {
  const value = e.target.value;
  if (value === "All Roof") {
    dispatch(
      updateQuantityInfo({ electricalConfiguration: value, allRoof: true })
    );
  } else {
    dispatch(
      updateQuantityInfo({ electricalConfiguration: value })
    );
  }
};

export const handlePreview = ({
  userInfo,
  setDisclaimerEmpty,
  setShowFeatureSelection,
  setReport,
}) => {
  if (
    !userInfo.reportInfo.disclaimerTermsCondition ||
    !userInfo.reportInfo.companyAddress ||
    !userInfo.reportInfo.companyPhoneNo ||
    !userInfo.reportInfo.companyEmail
  ) {
    setDisclaimerEmpty(true);
  } else {
    setDisclaimerEmpty(false);
    setShowFeatureSelection(false);
    setReport(true);
  }
};

export const handlePreviewOption = (dispatch, item, setShowPreview) => {
  const selectedProject = item;
  const value = selectedProject.value;
  dispatch(projectInfo({ value: value }));
  dispatch(updateQuantityInfo(selectedProject.quantityInfo));
  dispatch(
    updateProjectImg({
      structureImage: selectedProject.structureImageUrl,
    })
  );
  setShowPreview(true);
};

export const structureData = [
  {
    name: "Smith P1",
    width: 2.305,
    height: 1.51637,
    gap: 0.64419,
    price: 4500,
    midClamp: 2,
    endClamp: 0,
    structureParts: "../images/structureParts/P1.png",
    articleName: "BHSMP101",
  },
  {
    name: "Smith L1",
    width: 2.305,
    height: 1.51637,
    gap: 0.64419,
    price: 4500,
    midClamp: 0,
    endClamp: 4,
    structureImage: "./images/flat/smithL1.webp",
    structureImgSrc: "./images/structureTransparent/L1smith1.svg",
    structureParts: "../images/structureParts/L1.png",
    structureWatt: 1,
    roofType: "Flat Roof",
    articleName: "BHSML101",
  },
  {
    name: "Smith L2",
    width: 2.305,
    height: 2.48147,
    gap: 1.06695,
    price: 7800,
    midClamp: 2,
    endClamp: 4,
    structureImage: "./images/flat/smithL2.webp",
    structureImgSrc: "./images/structureTransparent/L2smith1.svg",
    structureParts: "../images/structureParts/L2.png",
    structureWatt: 2,
    roofType: "Flat Roof",
    articleName: "BHSML201",
  },
  {
    name: "Smith L3",
    width: 2.305,
    height: 3.53816,
    gap: 1.52632,
    price: 11800,
    midClamp: 4,
    endClamp: 4,
    structureImage: "./images/flat/smithL3.webp",
    structureImgSrc: "./images/structureTransparent/L3smith1.svg",
    structureParts: "../images/structureParts/L3.webp",
    structureWatt: 3,
    roofType: "Flat Roof",
    articleName: "BHSML301",
  },
  {
    name: "Smith Pro L",
    width: 2.254,
    height: 1.158,
    gap: 0.025,
    price: 1200,
    midClamp: 0,
    endClamp: 0,
    structureImage: "./images/shed/ProL.webp",
    structureImgSrc: "./images/structureTransparent/ProL1.svg",
    structureParts: "../images/structureParts/ProL.png",
    structureWatt: 1,
    roofType: "Shed Roof",
    articleName: "BHSMPL01",
  },
  {
    name: "Smith Through Rail L",
    width: 2.254,
    height: 1.158,
    gap: 0.025,
    price: 1200,
    structureImage: "./images/shed/ThroughRailL.png",
    structureImgSrc: "./images/structureTransparent/ProL1.svg",
    structureParts: "../images/structureParts/ProL.png",
    structureWatt: 1,
    roofType: "Shed Roof",
    articleName: "BHSMPL01",
  },
  {
    name: "Smith Pro P",
    width: 1.158,
    height: 2.254,
    gap: 0.025,
    price: 1200,
    midClamp: 0,
    endClamp: 0,
    structureImage: "./images/shed/ProP.webp",
    structureImgSrc: "./images/structureTransparent/ProP1.svg",
    structureParts: "../images/structureParts/ProP.png",
    structureWatt: 1,
    roofType: "Shed Roof",
    articleName: "BHSMPP01",
  },
  {
    name: "Smith Through Rail P",
    width: 1.158,
    height: 2.254,
    gap: 0.025,
    price: 1200,
    structureImage: "./images/shed/ThroughRailL.png",
    structureImgSrc: "./images/structureTransparent/ProP1.svg",
    structureParts: "../images/structureParts/ProP.png",
    structureWatt: 1,
    roofType: "Shed Roof",
    articleName: "BHSMPP01",
  },
  {
    name: "Customized",
    width: 1.158,
    height: 4.636,
    gap: 3.2,
    price: 112500,
    midClamp: 12,
    endClamp: 8,
    supportClamp: 16,
    rails: 4,
    beam: 2,
    polls: 6,
    feet: 4,
    nutBoltsLarge: 12,
    nutBoltsSmall: 24,
    structureImage: "./images/icons/customized.webp",
    structureImgSrc: "../images/structureTransparent/customized1.svg",
    structureParts: "../images/structureParts/customized.png",
    structureWatt: 2,
    roofType: "Customized Roof",
    articleName: "BHSMC01",
  },
  {
    name: "Smith ELITE(Carport)",
    width: 4.632,
    height: 4.636,
    gap: 3.2,
    price: 112500,
    midClamp: 12,
    endClamp: 8,
    structureParts: "../images/structureParts/customized.png",
    articleName: "BHSMP101",
  },
  {
    name: "Single Carport",
    width: 4.632,
    height: 4.636,
    gap: 3.2,
    price: 112500,
    midClamp: 12,
    endClamp: 8,
    supportClamp: 16,
    rails: 4,
    beam: 2,
    polls: 6,
    feet: 4,
    nutBoltsLarge: 12,
    nutBoltsSmall: 24,
    structureImage: "./images/icons/customized.webp",
    structureImgSrc: "../images/structureTransparent/carport1.svg",
    structureParts: "../images/structureParts/customized.png",
    structureWatt: 8,
    roofType: "Carport",
    articleName: "BHSMC01",
  },
  {
    name: "Double Carport",
    width: 4.632,
    height: 4.636,
    gap: 0,
    price: 112500,
    midClamp: 12,
    endClamp: 8,
    supportClamp: 16,
    rails: 4,
    beam: 2,
    polls: 6,
    feet: 4,
    nutBoltsLarge: 12,
    nutBoltsSmall: 24,
    structureImage: "./images/icons/customized.webp",
    structureImgSrc: "../images/structureTransparent/carport1.svg",
    structureParts: "../images/structureParts/customized.png",
    structureWatt: 8,
    roofType: "Carport",
    articleName: "BHSMC01",
  },
  {
    name: "Ground Mount",
    height: 1516.37,
    gap: 1516.37,
    price: 1500,
    midClampMultiply: 2,
    structureImage: "./images/icons/groundMount.webp",
    structureImgSrc: "./images/roofTypes/Groundmount.webp",
    structureParts: "../images/structureParts/customized.png",
    structureWatt: 8,
    roofType: "Ground Mount",
    articleName: "BHSMGM01",
  },
];
